import { useEffect, FC } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * HOC that adds a title to the page (use it only on the page components).
 * @param Component - The page component to add the title to.
 * @param title - The key of the title in the translation file or title string.
 * @param withTranslation - Whether to use the translation hook or not. @default true
 * @returns The component with the title.
 */
export const withTitle = (Component: FC, title: string, withTranslation = true) => {
  const WithTitle = (): JSX.Element => {
    const { t } = useTranslation();
    useEffect(() => {
      document.title = withTranslation ? t(title) : title;
    }, [title]);

    return <Component />;
  };
  WithTitle.displayName = `withTitle-${Component.displayName || Component.name}`;

  return WithTitle;
};
